// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"AddOrUpdateEmailTemplateModal_inputBox__VCGrZ"};